/* This example requires Tailwind CSS v2.0+ */
import { NewspaperIcon, PhoneIcon, SupportIcon } from '@heroicons/react/outline';

const supportLinks = [
  {
    name: 'Technology',
    href: '#',
    description: {
      list: [
        'CBCT 3D X-Ray',
        'Digital X-Ray',
        'Intra Oral Camera',
        'CEREC Technology',
        'LightScalpel CO2 Laser',
        'Diode Laser'
      ]
    }
  },
  {
    name: 'In-Network With Most PPOs',
    href: '#',
    description: {
      list: [
        'Delta Dental',
        'MetLife',
        'Cigna',
        'Premera',
        'Aetna',
        'United Healthcare',
        'Regence',
        'Humana',
        'And more....'
      ]
    },
    icon: SupportIcon,
  },
  {
    name: 'Financing Options',
    href: '#',
    description: {
      list: [
        'Sunbit',
        'Care Credit',
        'Lending Point'
      ]
    },
    icon: NewspaperIcon,
  },
]

export default function FeatureSection() {
  return (
    <div className="bg-gray-50">
      {/* Header */}

      {/* Overlapping cards */}
      <section className="max-w-7xl mx-auto relative z-10 py-16 px-4 sm:px-6 lg:px-8"
        aria-labelledby="contact-heading"
      >
        <h2 className="sr-only" id="contact-heading">
          Contact us
        </h2>
        <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8">
          {supportLinks.map((link) => (
            <div key={link.name} className="flex flex-col bg-white rounded-2xl shadow-xl">
              <div className="flex-1 relative pt-8 px-6 pb-8 md:px-8">
                <h3 className="text-lg text-center font-medium text-gray-900">{link.name}</h3>
                <p className="mt-4 text-base text-gray-500">{link.description.list ? link.description.list.map(item => <div class="text-center">{item}</div>) : link.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}
